import Vue from 'vue'
import VueRouter, { isNavigationFailure } from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

// Vue Router 3 rejects interrupted navigations; callers may omit a catch handler.
for (const method of ['push', 'replace']) {
    const original = VueRouter.prototype[method]
    VueRouter.prototype[method] = function navigate(location, onComplete, onAbort) {
        if (onComplete || onAbort) {
            return original.call(this, location, onComplete, onAbort)
        }
        return original.call(this, location).catch((err) => {
            if (isNavigationFailure(err)) return err
            throw err
        })
    }
}

// 无需登录态即可访问的路由（白名单）
const PUBLIC_PATHS = ['/login']
const getDefaultAdminPath = () => '/admin/workbench'

const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'login',
        meta: { public: true },
        component: () => import('../views/index.vue'),
    },
    {
        path: '/admin',
        component: () => import('../views/layout/index.vue'),
        redirect: getDefaultAdminPath,
        children: [
            {
                path: 'personal',
                name: 'personal',
                meta: { title: '个人中心' },
                component: () => import('../views/personal/index.vue'),
            },
            {
                path: 'demo',
                name: 'demo',
                meta: { title: '测试页面' },
                component: () => import('../views/demo/index.vue'),
            },
            {
                path: 'workbench',
                name: 'workbench',
                meta: { title: '工作台', affix: true },
                component: () => import('../views/workbench/index.vue'),
            },
            {
                path: 'owner',
                name: 'owner',
                meta: { title: '业主单位管理' },
                component: () => import('../views/owner/index.vue'),
            },
            {
                path: 'inquiry',
                name: 'inquiry',
                meta: { title: '询价管理' },
                component: () => import('../views/inquiry/index.vue'),
            },
            {
                path: 'inquiry/detail',
                name: 'inquiryDetail',
                meta: { title: '询价管理', tabPath: '/admin/inquiry' },
                component: () => import('../views/inquiry/detail.vue'),
            },
            {
                path: 'purchase-order',
                name: 'purchaseOrder',
                meta: { title: '采购订单管理' },
                component: () => import('../views/purchase-order/index.vue'),
            },
            {
                path: 'purchase-order/detail',
                name: 'purchaseOrderDetail',
                meta: { title: '采购订单管理', tabPath: '/admin/purchase-order' },
                component: () => import('../views/purchase-order/detail.vue'),
            },
            {
                path: 'supplier-order',
                name: 'supplierOrder',
                meta: { title: '供应商订单管理' },
                component: () => import('../views/supplier-order/index.vue'),
            },
            {
                path: 'supplier-order/detail',
                name: 'supplierOrderDetail',
                meta: { title: '供应商订单管理', tabPath: '/admin/supplier-order' },
                component: () => import('../views/supplier-order/detail.vue'),
            },
            {
                path: 'supplier-order/purchase-detail',
                name: 'supplierOrderPurchaseDetail',
                meta: { title: '供应商订单管理', tabPath: '/admin/supplier-order' },
                component: () => import('../views/supplier-order/purchase-detail.vue'),
            },
            {
                path: 'report',
                name: 'report',
                meta: { title: '查看报表' },
                component: () => import('../views/report/index.vue'),
            },
            {
                path: 'system/departments',
                name: 'systemDepartments',
                meta: { title: '部门管理' },
                component: () => import('../views/system/departments.vue'),
            },
            {
                path: 'system/menus',
                name: 'systemMenus',
                meta: { title: '菜单管理' },
                component: () => import('../views/system/menus.vue'),
            },
            {
                path: 'system/staff',
                name: 'systemStaff',
                meta: { title: '员工管理' },
                component: () => import('../views/system/staff.vue'),
            },
            {
                path: 'basic/contract-templates',
                name: 'contractTemplate',
                meta: { title: '销售合同模板管理' },
                component: () => import('../views/contract-template/index.vue'),
            },
            {
                path: 'basic',
                name: 'basicConfig',
                meta: { title: '基础配置' },
                component: () => import('../views/basic/index.vue'),
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
})

router.beforeEach((to, from, next) => {
    const token = getToken()
    const isPublic = PUBLIC_PATHS.indexOf(to.path) !== -1 || to.matched.some((route) => route.meta && route.meta.public)

    // 登录页：已登录则进工作台，未登录直接放行
    if (isPublic) {
        if (token && to.path === '/login') {
            next(getDefaultAdminPath())
            return
        }
        next()
        return
    }

    // 其余页面均需登录态，未登录跳转首页（登录页）
    if (!token) {
        next('/login')
        return
    }

    next()
})

export default router
